import { z } from 'zod';

export const anonymousReportCategories = [
  'stress',
  'harassment',
  'mental_health',
  'physical_health',
  'work_environment',
  'coworker_conflict',
  'workload',
  'personal',
  'suggestion',
  'other'
] as const;

export const anonymousReportSeverities = ['low', 'medium', 'high', 'critical'] as const;

export const anonymousReportStatuses = ['pending', 'reviewing', 'in_progress', 'resolved', 'closed'] as const;

export const contactTypes = ['mental_health', 'physical_health', 'both'] as const;

export const categoryLabels: Record<typeof anonymousReportCategories[number], string> = {
  stress: 'Estrés laboral',
  harassment: 'Acoso/Discriminación',
  mental_health: 'Salud mental',
  physical_health: 'Salud física',
  work_environment: 'Ambiente laboral',
  coworker_conflict: 'Conflictos con compañeros',
  workload: 'Carga de trabajo',
  personal: 'Problemas personales',
  suggestion: 'Sugerencias',
  other: 'Otro'
};

export const severityLabels: Record<typeof anonymousReportSeverities[number], string> = {
  low: 'Baja',
  medium: 'Media',
  high: 'Alta',
  critical: 'Crítica'
};

export const statusLabels: Record<typeof anonymousReportStatuses[number], string> = {
  pending: 'Pendiente',
  reviewing: 'En revisión',
  in_progress: 'En progreso',
  resolved: 'Resuelto',
  closed: 'Cerrado'
};

export const contactTypeLabels: Record<typeof contactTypes[number], string> = {
  mental_health: 'Salud mental',
  physical_health: 'Salud física',
  both: 'Ambas'
};

// Schema para crear reporte anónimo
export const anonymousReportFormSchema = z.object({
  category: z.enum(anonymousReportCategories, {
    required_error: 'Selecciona una categoría'
  }),
  subject: z.string()
    .min(5, 'El asunto debe tener al menos 5 caracteres')
    .max(255, 'El asunto no puede exceder 255 caracteres'),
  description: z.string()
    .min(20, 'La descripción debe tener al menos 20 caracteres')
    .max(5000, 'La descripción no puede exceder 5000 caracteres'),
  severity: z.enum(anonymousReportSeverities).default('medium'),
  request_professional_contact: z.boolean().default(false),
  contact_type: z.enum(contactTypes).optional().nullable(),
});

// Schema para respuesta de admin
export const anonymousReportAdminSchema = z.object({
  status: z.enum(anonymousReportStatuses),
  admin_notes: z.string().max(2000).optional().nullable(),
  admin_response: z.string().max(2000).optional().nullable(),
});

export type AnonymousReportFormData = z.infer<typeof anonymousReportFormSchema>;
export type AnonymousReportAdminData = z.infer<typeof anonymousReportAdminSchema>;
